import { render } from "./EmailOrMobileInput.vue?vue&type=template&id=5fdd8b12&scoped=true"
import script from "./EmailOrMobileInput.vue?vue&type=script&lang=js"
export * from "./EmailOrMobileInput.vue?vue&type=script&lang=js"

import "./EmailOrMobileInput.vue?vue&type=style&index=0&id=5fdd8b12&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fdd8b12"]])

export default __exports__